import Pochta from "./Pochta";
function ENTP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
           <div className="image-wrapper">
      <img src="/img/ENTP Полемист.png" className="ENFP"/>
      </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>ENTP</h2>
     <p><strong>Процент населения:</strong> 3–5%</p>
<p><strong>Среди мужчин:</strong> 4–6%</p>
<p><strong>Среди женщин:</strong> 2–3%</p>
<p><strong>Стратегия:</strong> Генерация идей</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ENTP черпают энергию из общения и интеллектуальных споров. 
  Им нужны новые идеи, дискуссии и вызовы. 
  Они восстанавливают силы, обсуждая концепции и решая головоломки.
</p>
<p>
  Решения ENTP принимают на основе логики и интуиции. 
  Они доверяют своему уму и любят находить нестандартные решения. 
  Они ценят интеллект, свободу и возможность спорить.
</p>
<p>
  Это изобретательные и энергичные люди. 
  Они всегда генерируют идеи и находят лазейки. 
  Им трудно доводить дела до конца, но их креативность поражает.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ENTP — это вечный спорщик. Он будет доказывать, что трава синяя, просто потому что это интересно. 
  Они утомляют своей энергией, переключаются между темами со скоростью света и никогда не доводят дела до конца. 
  Им скучно с теми, кто не спорит, и они могут казаться токсичными, хотя просто ищут истину.
</p>

<p>
  ENTP — это человек, который может продать снег эскимосу, а потом объяснить, почему это было логично. 
  Они видят 100 решений проблемы за 5 минут, но не запоминают, где оставили ключи. 
  Их энергия — как искрящий провод: интересно, но опасно подходить слишком близко. 
  И именно это делает их гениальными.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ENTP;